export const orange = {
  190: '#1A0B00',
  175: '#401C00',
  150: '#803700',
  125: '#BF5300',
  100: '#FF6E00',
  75: '#FF9240',
  50: '#FFB680',
  25: '#FFDBBF',
  15: '#ffe4d0',
  10: '#FFF0E5',
  5: '#fff5eb',
  2: '#fff9f5',
};

export type OrangeVariants = keyof typeof orange;
